import { Pagination } from "@saleor/types";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { TranslationsEntitiesListFilterTab } from "./components/TranslationsEntitiesListPage";

export enum TranslatableEntities {
  shop = "shop",
  categories = "categories",
  products = "products",
  extraCharges = "extraCharges",
  collections = "collections",
  sales = "sales",
  vouchers = "vouchers",
  pages = "pages",
  pageHeader = "pageHeader",
  productTypes = "productTypes",
  productVariant = "productVariant",
  productTag = "productTag",
  menuItem = "menuItem",
  menuBanner = "menuBanner",
  hotWord = "hotWord",
  cornerMark = "cornerMark",
  shippingMethod = "shippingMethod",
  cover = "cover",
  loginPopup = "loginPopup",
  combo = "combo",
  productActivationSetting = "productActivationSetting",
  productLensType = "productLensType"
}

const translationsSection = "/translations/";

export const languageListPath = translationsSection;
export const languageListUrl = translationsSection;

export const languageEntitiesPath = (code: string) =>
  urlJoin(translationsSection, code);
export type LanguageEntitiesUrlQueryParams = Pagination &
  Partial<{
    query: string;
    tab: TranslationsEntitiesListFilterTab;
  }>;
export const languageEntitiesUrl = (
  code: string,
  params: LanguageEntitiesUrlQueryParams
) => languageEntitiesPath(code) + "?" + stringifyQs(params);

export const languageEntityPath = (
  code: string,
  entity: TranslatableEntities,
  id: string
) => urlJoin(languageEntitiesPath(code), entity.toString(), id);
export const languageEntityUrl = (
  code: string,
  entity: TranslatableEntities,
  id: string
) => languageEntityPath(code, entity, encodeURIComponent(id));
